import React from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../../../redux/configureStore';
import { setFinalValueOption } from '../../../../../../../../../../redux/fetchActions/legadoPage/transferApp';
import {
  convertToNumber,
  convertToReal,
} from '../../../../../../../../../../utils/values';

function SetInitialValue() {
  const dispatch = useDispatch();
  const transferssFilterState = useSelector(
    (reducer: IReducer) => reducer.transfersFilterApp
  );

  function setValue(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    const currency = convertToNumber(value);
    if (currency > 99999999) {
      dispatch(setFinalValueOption(convertToReal(9999999)));
    } else {
      dispatch(setFinalValueOption(convertToReal(currency)));
    }
  }

  return (
    <Form.Control
      type="text"
      value={transferssFilterState.value.to}
      onChange={(event) => setValue(event)}
    />
  );
}

export default SetInitialValue;
